import { useState, useEffect } from 'react';

function hashSeed(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) - h + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

function getScore(equipment: string): number {
  const now = new Date();
  const dateStr = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;
  const block = Math.floor(now.getHours() / 3);
  const seed = hashSeed(`${dateStr}-${block}-${equipment}`);
  return 65 + (seed % 32); // 65–96
}

export function useMarketPressureIndex(equipment: string) {
  const [score, setScore] = useState(() => getScore(equipment));

  useEffect(() => {
    setScore(getScore(equipment));
    const id = setInterval(() => setScore(getScore(equipment)), 60_000);
    return () => clearInterval(id);
  }, [equipment]);

  const label = score > 85 ? 'Hot' : score > 70 ? 'Warm' : 'Cool';
  const labelColor = score > 85 ? 'text-destructive' : score > 70 ? 'text-yellow-500' : 'text-success';

  return { score, label, labelColor };
}
